import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { DeliveryIndicatorFullDateContainer } from '../containers/DeliveryIndicatorFullDate.js';
import { DeliveryIndicatorBasicContainer } from '../containers/DeliveryIndicatorBasic.js';

var DeliveryIndicator = (_param)=>{
    var { items =[] , deliveryResolver , availability , fallbackLabel  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "items",
        "deliveryResolver",
        "availability",
        "fallbackLabel"
    ]);
    const { isDeliveryFullDateEnabled  } = useFeatureToggles();
    const { getLabel  } = useIntl();
    const fallbackLabelValue = fallbackLabel !== null && fallbackLabel !== void 0 ? fallbackLabel : getLabel('products.deliveryIndicator.fallbackMessage');
    // Full date delivery indicator that fetches a calculated delivery estimate from the backend
    if (isDeliveryFullDateEnabled && (items === null || items === void 0 ? void 0 : items.length) > 0) {
        return /*#__PURE__*/ React__default.createElement(DeliveryIndicatorFullDateContainer, swcHelpers.extends({
            items: items,
            fallbackLabel: fallbackLabelValue
        }, rest));
    }
    return(// Basic delivery indicator that renders delivery estimate based on stock levels
    /*#__PURE__*/ React__default.createElement(DeliveryIndicatorBasicContainer, swcHelpers.extends({
        deliveryResolver: deliveryResolver,
        availability: availability,
        fallbackLabel: fallbackLabelValue
    }, rest)));
};

export { DeliveryIndicator };
//# sourceMappingURL=DeliveryIndicator.js.map
